import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * TODO: this should be its own standalone util function
 */
import React from "react";
/**
 * `derivePropsFromChild`
 */

/**
 * `injectPropsToChildren` drill the provided container props down to its children components
 * it is intended to be used for shallow node trees.
 *
 * for deeply nested trees or sibling trees, refer to `React.createContext`
 *
 *
 * @param children is the react children of the component you are calling `injectPropsToChildren` from
 * @param derivePropsFromChild is a function that will provide the derived props to the child node
 * `derivePropsFromChild` must always return an object of props
 * @returns the children with derived props
 *
 * @example
 * injectPropsToChildren(children,
 *  (child) => {
 *    const { type, props } = child
 *    if(type === MyComponent){
 *      return {
 *        title: props.bar === "hello",
 *        onClick: this.handleClick
 *      }
 *    }
 *    return props
 *  }
 * )
 *
 */
var injectPropsToChildren = function injectPropsToChildren(children, derivePropsFromChild) {
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return React.Children.map(children, function (child) {
    var isDeepInjectable = deep && child.props.children;
    var isFragmentWithChildren = child.type === React.Fragment && child.props.children;
    var shouldDoRecursiveInjection = isDeepInjectable || isFragmentWithChildren;
    var propsToPass = derivePropsFromChild(child);

    if (shouldDoRecursiveInjection) {
      propsToPass = _objectSpread(_objectSpread({}, propsToPass), {}, {
        children: injectPropsToChildren(child.props.children, derivePropsFromChild, deep)
      });
    }

    if (typeof child === "string") {
      return child;
    }

    return /*#__PURE__*/React.cloneElement(child, propsToPass);
  });
};

export default injectPropsToChildren;